import request from 'supertest'
import { app } from '@/infra/app'
import { prismaService as prisma } from '@/infra/database/prisma'
import { LeadFactory } from '../../../../test/factories/makeLead'
import { randomUUID } from 'crypto'

describe('Fetch Leads By Origin (E2E)', () => {
  let leadFactory: LeadFactory
  beforeEach(async () => {
    leadFactory = new LeadFactory(prisma)
  })

  test('[GET] /leads/origin/:originId/list', async () => {
    const originId = randomUUID()
    await Promise.all([
      leadFactory.makePrismaLead({
        originId
      }),
      leadFactory.makePrismaLead({
        originId
      }),
      leadFactory.makePrismaLead({
        originId
      }),
    ])

    const response = await request(app).get(`/leads/origin/${originId}/list`).send()

    expect(response.status).toBe(200)
    expect(response.body.leads.length).toBe(3)
  })
  afterEach(async () => {
    await prisma.lead.deleteMany()
  })
})